import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Alert = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.336 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(-2 -.006)">
        <path d="M15.24 12.326A8.569 8.569 0 0 1 14 8V5.341a5.335 5.335 0 1 0-10.669 0V8A8.57 8.57 0 0 1 2.1 12.326a.667.667 0 0 0 .57 1.012h12a.667.667 0 0 0 .57-1.012z" />
        <path
          d="M11.73 23.219a2 2 0 0 0 1.213-1.213H9.174a2 2 0 0 0 2.556 1.213z"
          transform="translate(-2.39 -7.33)"
        />
      </g>
    </svg>
  );
};

Alert.displayName = 'Alert';
